import { 
  DailyBusinessReportRes,
  DailyIncomeReportRes,
  DailyStockReportRes,
  MonthlyBusinessReportRes,
  MonthlyIncomeReportRes,
  PostRes,
} from '@/store/pages/report/index.d';

// 类型别名
type ReportRes = DailyBusinessReportRes | DailyIncomeReportRes | DailyStockReportRes | MonthlyBusinessReportRes | MonthlyIncomeReportRes;

// formate date[日期格式化]
export const dateFormate = (startDate: Date | string) => {
  const year = new Date(startDate).getFullYear();
  const month = new Date(startDate).getMonth() + 1;
  const day = new Date(startDate).getDate();
  return `${year}-${month}-${day}`;
}

// init report data[表格数据初始化]
export const initReportData = (vm: any, funKey: string, key: string) => {
  let {
    report_id, 
    level, 
    start_date, 
    end_date, 
    store_group_id, 
    page, 
    count, 
    sort_field_id, 
    sort_order
  } = vm.$route.query;
  vm.reportId = ~~report_id;
  vm.$emit('levelPass', ~~level);
  const start = sessionStorage.getItem("start"); 
  const end = sessionStorage.getItem("end"); 
  if (start && level === '1') {
    start_date = start
    end_date = end
  }
  vm.$emit('datePass', dateFormate(start_date), dateFormate(end_date));
  vm.store_group_id = store_group_id === 'null' ? null : ~~store_group_id;
  vm.currentPage = page ? ~~page : 1;
  vm.pageSize = count ? ~~count : 10;
  vm.sort_field_id = sort_field_id ? ~~sort_field_id : 1;
  vm.sort_order = sort_order ? ~~sort_order : 2;
  vm[funKey]({
    reportId: vm.reportId,
    level: vm.level,
    start_date,
    end_date,
    store_group_id: vm.store_group_id,
    page: vm.currentPage,
    count: vm.pageSize,
    sort_field_id: vm.sort_field_id,
    sort_order: vm.sort_order,
  }).then((res: ReportRes) => {
    vm.$emit('loadingPass', false);
    if (vm.level !== 1) {
      vm.$emit('titlePass', vm[key].report_name, vm.$route.query.title);
    } else {
      vm.$emit('titlePass', vm[key].report_name);
    }
  });
}

// fetch report[获取报表数据]
export const fetchReport = (vm: any, funKey: string, params: any) => {
  vm.$emit('loadingPass', true);
  const { 
    reportId = vm.reportId, 
    level = vm.level, 
    start_date = dateFormate(vm.start), 
    store_group_id = vm.store_group_id, 
    end_date = dateFormate(vm.end), 
    page = vm.currentPage, 
    count = vm.pageSize, 
    sort_field_id = vm.sort_field_id, 
    sort_order = vm.sort_order 
  } = params;
  vm.config = { reportId, level, start_date, end_date, store_group_id, page, count, sort_field_id, sort_order, }
  vm[funKey]( vm.config ).then((res: ReportRes) => {
    vm.$emit('loadingPass', false);
  });
}

// sort data [排序]
export const sortChange = (vm: any, key: string, params: any) => {
  const { column, order, prop } = params;
  vm.$nextTick(() => {
    if (column) {
      const { id } = column;
      vm.sort_field_id = vm[key].fields[prop].field_id;
    }
    if (order === 'descending') {
      vm.sort_order = 0;
    } else if (order === 'ascending') {
      vm.sort_order = 1;
    } else if (order === null) {
      vm.sort_order = 2;
    }
    vm.fetchReport({});
  })
}

// render header[表格头部三角渲染]
export const renderHeader = (vm: any, key: string, h: any, {column, $index}: any) => {
  return h('span', [
    h('span', column.label),
    h('span', {
      class: 'errorIcon',
      style: {
        position: 'absolute',
        display: 'block',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        borderTop: '12px solid transparent',
        borderRight: '12px solid #1ba2fc',
      },
      on: {
        click: (event: any) => {
          vm.dialogSettingTableVisible = true;
          const { property, label } = column;
          vm.property = property;
          vm.label = label;
          if (vm[key].fields[property]) {
            vm.fileds = vm[key].fields[property].field_id;
            const benchmarks = vm[key].fields[property].benchmarks;
            vm.formLabelAlign.value1 = benchmarks[0];
            vm.formLabelAlign.value2 = benchmarks[1];
            vm.formLabelAlign.value3 = benchmarks[2];
          }
          event.stopPropagation();
        }
      }
    })
  ])
}

// style calculation[样式计算]
export const styleCal = ( vm: any, key: string, row: any, name: string, value: number ) => {
  if (row === 0) {
    return;
  }
  if (vm[key].fields[name].benchmarks) {
    const benchmark =  ​JSON.parse(JSON.stringify(vm[key].fields[name].benchmarks));
    const _benchmark = benchmark.filter((item: any) => {
      return item;
    })
    const benchmarks = _benchmark.sort((a: number, b: number) => {
      return a - b;
    })
    if (benchmarks.length === 0) {
      return;
    } else if (benchmarks[2]) {
      if (value >= benchmarks[0] && value < benchmarks[1]) {
        return 'light';
      } else if (value >= benchmarks[1] && value < benchmarks[2]) {
        return 'midium';
      } else if (value >= benchmarks[2]) {
        return 'dark';
      }
    } else if (benchmarks[1]) {
      if (value >= benchmarks[0] && value < benchmarks[1]) {
        return 'light';
      } else if (value >= benchmarks[1]) {
        return 'midium';
      }
    } else if (benchmarks[0]) {
      if (value >= benchmarks[0]) {
        return 'light';
      }
    } 
  }
}

// click to jump[点击页面跳转]
export const cellClick = (vm: any, key: string, row: any, column: any, cell: any, flag: boolean) => {
  const { date, store_group, id } = row;
  const { property } = column;
  if (date !== '总计' && property === 'store_group.name' && vm.level === 1) {
    const title = flag ? `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日全部门店组` : `${date.split('-')[0]}年${date.split('-')[1]}月全部门店组`;
    vm.$router.push({
      path: `/index/report/${key}/level2`,
      query: {
        report_id: vm.$route.query.report_id,
        level: `2`,
        start_date: `${dateFormate(date)}`, 
        store_group_id: `${vm.store_group_id}`, 
        end_date: `${dateFormate(date)}`, 
        page: `${vm.currentPage}`, 
        count: `${vm.pageSize}`, 
        sort_field_id: `${vm.sort_field_id}`, 
        sort_order: `${vm.sort_order}`,
        title,
      },
    })
    vm.$emit('datePass', dateFormate(date), dateFormate(date));
    vm.$emit('levelPass', 2);
  }
  if (date !== '总计' && property === 'store_name' && vm.level !== 3) {
    vm.store_group_id = vm[key].table[id].store_group.store_group_id;
    let title = '';
    if (vm[key].data_range === 1) {
      title = flag ? `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日${store_group.name}的门店` : `${date.split('-')[0]}年${date.split('-')[1]}月${store_group.name}的门店`;
    } else {
      title = '全部门店';
    }
    vm.$router.push({
      path: `/index/report/${key}/level3`,
      query: {
        report_id: vm.$route.query.report_id,
        level: `3`,
        start_date: `${dateFormate(date)}`, 
        store_group_id: `${vm.store_group_id}`, 
        end_date: `${dateFormate(date)}`, 
        page: `${vm.currentPage}`, 
        count: `${vm.pageSize}`, 
        sort_field_id: `${vm.sort_field_id}`, 
        sort_order: `${vm.sort_order}`,
        title,
      },
    })
    vm.$emit('datePass', dateFormate(date), dateFormate(date));
    vm.$emit('levelPass', 3);
  }
}

// save benchmarks[保存基准值]
export const saveBenchmarks = (vm: any, funKey: string, key: string, benchmarks: any) => {
  const updateReport = ​JSON.parse(JSON.stringify(vm[key]));
  updateReport.fields[vm.property].benchmarks = benchmarks;
  const params = {
    reportId: vm.reportId, 
    level: vm.level, 
    fileds: vm.fileds, 
    benchmarks, 
    updateReport, 
  };
  vm[funKey](
    params
  ).then((res: PostRes) => {
    vm.fetchReport({});
  });
}

// Fetch Report After Recovery[恢复原始报表后重新获取数据]
export const fetchReportAfterRecovery = (vm: any, funKey: string) => {
  vm.loading = true;
  const {
    start_date,
    end_date, 
    store_group_id,
    page, 
    count, 
    sort_field_id, 
    sort_order
  } = vm.$route.query;
  if (vm.level !== 1) {
    vm.start = start_date;
    vm.end = end_date;
  }
  const config = {   
    reportId: vm.reportId,
    level: vm.level,
    start_date: dateFormate(vm.start),
    end_date: dateFormate(vm.end), 
    store_group_id: store_group_id ? ~~store_group_id : null,
    page: page ? ~~page : 1,
    count: count ? ~~count : 10,
    sort_field_id: sort_field_id ? ~~sort_field_id : 1,
    sort_order: sort_order ? ~~sort_order : 1,
  }
  vm[funKey](config).then((res: ReportRes) => {
    vm.loading = false;
  });
}
